<template>
  <div class="np-accordion np-mb-2" :class="[
    options.additionalClasses,
    localState,
    { 'selected': options.selected }
  ]">
    <div 
      class="np-accordion-switcher" 
      :class="[options.size, { 'selected': options.selected }]" 
      @click="handleHeaderClick"
    >
      <slot name="header">Accordion header</slot>
      <svg 
        v-if="!options.hideArrow"
        class="right" 
        :class="{ 'rotated': isExpanded }"
        @click.stop="handleArrowClick"
      >
        <use href="@/assets/images/icons/arrow-down.svg#icon"></use>
      </svg>
    </div>
    
    <div class="np-accordion-body" v-if="isExpanded">
      <slot>Тут пока ничего нет :(</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
      default: () => ({
        state: 'collapsed',
        size: 'normal',
        selected: false,
        hideArrow: false,
        onlyArrow: false,
        additionalClasses: ''
      })
    }
  },
  emits: ['update:options', 'toggle'],
  data() {
    return {
      isExpanded: this.options.state === 'expanded'
    }
  },
  computed: {
    localState() {
      return this.isExpanded ? 'expanded' : 'collapsed'
    }
  },
  watch: {
    'options.state'(newState) {
      this.isExpanded = newState === 'expanded'
    }
  },
  methods: {
    updateState(newState) {
      this.isExpanded = newState === 'expanded'
      this.$emit('update:options', { 
        ...this.options, 
        state: newState 
      })
      this.$emit('toggle', newState)
    },
    handleHeaderClick() {
      if (this.options.onlyArrow) return
      this.updateState(this.isExpanded ? 'collapsed' : 'expanded')
    },
    handleArrowClick() {
      if (!this.options.onlyArrow) return
      this.updateState(this.isExpanded ? 'collapsed' : 'expanded')
    }
  }
}
</script>

<style scoped>
.right {
  transition: transform 0.2s ease;
}
.right.rotated {
  transform: rotate(180deg);
}
</style>